var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-container" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.loaded
          ? _c("div", { staticClass: "cover", style: _vm.coverStyle })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.url && !_vm.error
        ? _c("img", {
            staticClass: "image",
            style: _vm.imageStyle,
            attrs: { src: _vm.url, alt: _vm.alt },
            on: { error: _vm.errorHandler, load: _vm.loadHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }